import { useState, useEffect } from 'react';
import './signup.scss';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import useFaceBook from '../../hooks/useFaceBook';
import { useGetInfoQuery } from '../../api/dataApi';
import { useLoginMutation } from '../../api/dataApi';
import useMixpanel from '../../hooks/useMixpanel';
import CheckEmail from './components/CheckEmail';
import LoginEmail from './components/LoginEmail';
import MyButton from '../../components/UI/button/MyButton';
import { useDispatch } from 'react-redux';
import { setButtonClick } from '../../store/buttonSlice';
import { Link } from '@mui/material';
import SignupEmail from './components/SignupEmail';
import ConfirmForgetEmail from './components/ConfirmForgetEmail';
import EnterCode from './components/EnterCode';
import ResetPassword from './components/ResetPassword';
import ConfirmSignupEmail from './components/ConfirmSignupEmail';
import LoginToEmail from './components/LoginToEmail';
import SuccesLogin from './components/SuccesLogin';
import { transformProfileForBackend } from '../../common/consts/Profile.consts';

const Signup = ({ pageComponent, setPageComponent, termChange, privacyChange, setLoginChangeStatus, setSelectedOption, setButtonShow, setBlockPaddingBottom, setSignupBottom, signupBottom, buttonStatus, setButtonStatus, forgetPassword, setEventProperties, sessionId, setEventName }) => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  const [loginMutation, { isLoading: isLoginLoading, error: loginError }] = useLoginMutation();
  const [error, setError] = useState(false);
  const { trackP1Event } = useMixpanel();

  useEffect(() => {
    setButtonShow(false);
    setLoginChangeStatus(true)
    setSignupBottom('checkbox');
    setButtonStatus('checkEmail');
    setSelectedOption('1')
  }, []);



  const { data, refetch } = useGetInfoQuery();

  const [inputEmail, setInputEmail] = useState('');
  const [inputPassword, setInputPassword] = useState('');
  const [msgPassword, setMsgPassword] = useState('');
  const [inputPassword2, setInputPassword2] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [code, setCode] = useState(Array(6).fill(''));
  const { sendFb } = useFaceBook();
  const [emailChange, setEmailChange] = useState(false);
  useEffect(() => {
    sendFb("ViewContent", {});
  }, [])

  const [userNotFound, setUserNotFound] = useState(false);

  const logIn = async (ResetPassword, noPassword, wrongFormat, noMatch) => {
    try {
      const data = {
        email: inputEmail,
        password: inputPassword,
        os: 'web',
        withAuth: true
      };
      const response = await loginMutation(data).unwrap();
      setButtonStatus('');
      if (response.data.statusCode === 400 && response.data.message === 'Password is wrong') {
        setError(true);
        setMsgPassword('Sorry, you entered the wrong password. Please try again.')
        trackP1Event('web_loggedIn', {
          web_entrance: 'login',
          signin_success: "FALSE",
          email_changed: emailChange ? "TRUE" : "FALSE",
          error_reason: [
            noPassword && "no_password",
            "wrong_password"
          ].filter(Boolean).join(",") || "none"
        })
      } else {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem('authToken', response.data.authToken);
        localStorage.setItem('email', inputEmail);
        localStorage.setItem('signupMethod', 'Login');

        refetch()
        businessProfiles()
        sendUtm()
        sendData()

        window.gtag('event', 'conversion', { 'send_to': 'AW-17610941807/wHOcCNqMlasbEO_Kxs1B' });

        checkSubscribe(ResetPassword, noPassword, wrongFormat, noMatch)


        // history.push('/name');
      }
    } catch (err) {
      setError(true);
      console.log(err.data.message);
      if (err?.data?.message === 'User not found') {
        setUserNotFound(true);
      } else {
        setUserNotFound(false);
        setMsgPassword('Sorry, you entered the wrong password. Please try again.')
        trackP1Event('web_loggedIn', {
          web_entrance: 'login',
          signin_success: "FALSE",
          email_changed: emailChange ? "TRUE" : "FALSE",
          error_reason: [
            noPassword && "no_password",
            "wrong_password"
          ].filter(Boolean).join(",") || "none"
        })
      }
      setButtonStatus('');
    }
  };




  const checkSubscribe = (ResetPassword, noPassword, wrongFormat, noMatch) => {
    axios.get("https://staging.zeely.link/subscriptions/current", {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      redirect: 'follow'
    })
      .then(response => {
        console.log(response.data.data.status)

        if (response.data.data.status === 'ACTIVE' || response.data.data.status === 'REDEMPTION') {
          localStorage.setItem('subscriptionsStatus', 'paid')
          localStorage.setItem('userId', response.data.data.userId)

          if (ResetPassword) {
            trackP1Event('web_signin_success', {
              signin_success: "TRUE",
              user_id: response.data.data.userId,
              error_reason: [
                noPassword && "no_password",
                wrongFormat && "wrong_format",
                noMatch && "no_match"
              ].filter(Boolean).join(",") || "none"
            })
          } else {
            trackP1Event('web_loggedIn', {
              web_entrance: 'login',
              user_id: response.data.data.userId,
              signin_success: "TRUE",
              email_changed: emailChange ? "TRUE" : "FALSE",
              error_reason: [
                noPassword && "no_password",
              ].filter(Boolean).join(",") || "none"
            })
          }

          if (response?.data.data?.bundleStatus === 'ACTIVE') {
            history.push({
              pathname: '/thankyou',
              search: `?${queryParams.toString()}`,
            });

          } else {
            localStorage.setItem('bundleStatus', 'no')
            history.push({
              pathname: '/loader',
              search: `?${queryParams.toString()}`,
            });

          }
        } else {
          localStorage.setItem('subscriptionsStatus', 'free')

          checkName(ResetPassword, noPassword, wrongFormat, noMatch)
        }
      })
      .catch(error => {

        checkName(ResetPassword, noPassword, wrongFormat, noMatch)
      });
  }

  const checkName = (ResetPassword, noPassword, wrongFormat, noMatch) => {
    axios.get("https://staging.zeely.link/users", {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      redirect: 'follow'
    })
      .then(response => {
        localStorage.setItem('userId', response.data.data.id)
        if (ResetPassword) {
          trackP1Event('web_signin_success', {
            signin_success: "TRUE",
            user_id: response.data.data.userId,
            error_reason: [
              noPassword && "no_password",
              wrongFormat && "wrong_format",
              noMatch && "no_match"
            ].filter(Boolean).join(",") || "none"
          })
        } else {
          trackP1Event('web_loggedIn', {
            web_entrance: 'login',
            user_id: response.data.data.userId,
            signin_success: "TRUE",
            email_changed: emailChange ? "TRUE" : "FALSE",
            error_reason: [
              noPassword && "no_password",
            ].filter(Boolean).join(",") || "none"
          })
        }

        if (response.data.data.name && response.data.data.name.length) {
          setPageComponent('signinSuccess')

        } else {
          setPageComponent('signinSuccess');
        }
      })
      .catch(error => {
        // history.push('/name');
      });
  }

  const signUp = (noPassword, wrongFormat) => {
    const data = {
      email: inputEmail,
      password: inputPassword,
      os: 'web',
      withAuth: true
    };

    axios.post("https://staging.zeely.link/users/register", data, {
      headers: {
        "Content-Type": "application/json"
      },
      redirect: 'follow'
    })
      .then(response => {
        console.log(response)
        if (response.data.statusCode === 400 && response.data.message === 'User already exist') {
          setButtonStatus('signUp');
        } else {
          // mixpanel.track('', {
          //     session_id: sessionId,

          //     web_utm_campaign: localStorage.getItem("utmCampaign"),
          //     web_utm_source: localStorage.getItem("utmSource"),
          //     web_utm_medium: localStorage.getItem("utmMedium"),
          //     web_utm_content: localStorage.getItem("utmContent"),
          //     web_utm_term: localStorage.getItem("utmTerm"),
          //     isDebug: false,
          //     funnel: process.env.REACT_APP_FUNNEL,
          // });


          localStorage.setItem("accessToken", response.data.data.accessToken);
          localStorage.setItem('authToken', response.data.data.authToken);
          localStorage.setItem('email', inputEmail);
          refetch()
          businessProfiles();
          sendUtm()
          sendData()

          window.gtag('event', 'conversion', { 'send_to': 'AW-17610941807/wHOcCNqMlasbEO_Kxs1B' });

          axios.get("https://staging.zeely.link/users", {
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
          })
            .then(response => {
              trackP1Event('web_signup_confirm', {
                user_id: response.data.data.id,
                web_entrance: "signup",
                email_changed: emailChange ? "TRUE" : "FALSE",
                error_reason: [
                  noPassword && "no_password",
                  wrongFormat && "wrong_format",
                ].filter(Boolean).join(",") || "none",

              });
              localStorage.setItem('userId', response.data.data.id)
              history.push({
                pathname: '/name',
                search: `?${queryParams.toString()}`,
              });
            })
            .catch(error => {
              // history.push('/name');
            });
          // history.push('/name');
        }
      })
      .catch(error => {
        setButtonStatus('');
      });
  };

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source") || '';
  const utmMedium = urlParams.get("utm_medium") || '';
  const utmCampaign = urlParams.get("utm_campaign") || '';
  const utmContent = urlParams.get("utm_content") || '';
  const utmTerm = urlParams.get("utm_term") || '';

  const sendData = async () => {
    const formdata = new FormData();
    formdata.append("domen", window.location.hostname + process.env.REACT_APP_BASENAME);
    formdata.append("email", inputEmail);
    formdata.append("utmSource", utmSource);
    formdata.append("utmMedium", utmMedium);
    formdata.append("utmCampaign", utmCampaign);
    formdata.append("utmContent", utmContent);
    formdata.append("utmTerm", utmTerm);
    try {
      const response = await axios.post("https://zee.sale/send-1-ai.php", formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };


  const sendUtm = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const data = {
      "utmSource": urlParams.get("utm_source") || "default_source",
      "utmMedium": urlParams.get("utm_medium") || "default_medium",
      "utmCampaign": urlParams.get("utm_campaign") || "default_campaign",
      "utmTerm": urlParams.get("utm_term") || "default_term",
      "utmContent": urlParams.get("utm_content") || "default_content",
      "url": window.location.hostname
    };
    axios.post("https://staging.zeely.link/users/utm", data, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      redirect: 'follow'
    })
      .then(response => {
        console.log(response)

      })
      .catch(error => {
        console.log(error)
      });
  }

  const businessProfiles = () => {

    var profilesJSON = localStorage.getItem('business-profiles');
    if (profilesJSON) {
      var profiles = JSON.parse(profilesJSON);
      profiles.forEach(function (profile) {
        profile.email = inputEmail;
      });
      var updatedProfilesJSON = JSON.stringify(profiles);
      localStorage.setItem('business-profiles', updatedProfilesJSON);
    } else {
      var newProfile = {
        email: inputEmail
      };
      var newProfiles = [newProfile];
      var newProfilesJSON = JSON.stringify(newProfiles);
      localStorage.setItem('business-profiles', newProfilesJSON);
    }

    const fullJSON = localStorage.getItem('business-profiles');
    const profile = JSON.parse(fullJSON)[0];

    const transformedProfile = transformProfileForBackend(profile);

    const data = JSON.stringify(transformedProfile);

    axios.post("https://staging.zeely.link/business-profiles", data, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      },
      redirect: 'follow'
    })
      .then(response => {
        localStorage.setItem('business-profiles-id', response.data.data.id);
      })
      .catch(error => {
        console.log(error)
      });
  };

  const handlePasswordChange = (e) => {
    setInputPassword(e.target.value);
  };

  const handlePassword2Change = (e) => {
    setInputPassword2(e.target.value);
  };

  const dispatch = useDispatch()

  const handleContinueClick = () => {
    dispatch(setButtonClick(true))
  };


  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);

  const [buttonText, setButtonText] = useState('');
  const [buttonIcon, setButtonIcon] = useState('');

  useEffect(() => {
    trackP1Event('web_signup_view', {
    })
  }, [])



  return (
    <div style={{ paddingBottom: "0rem" }}>
      {pageComponent === 'checkEmail' && (
        <CheckEmail
          setButtonStatus={setButtonStatus}
          error={error}
          inputEmail={inputEmail}
          setInputEmail={setInputEmail}
          setPageComponent={setPageComponent}
          setError={setError}
          setButtonText={setButtonText}
        />
      )}
      {pageComponent === 'loginToEmail' && (
        <LoginToEmail
          setButtonStatus={setButtonStatus}
          error={error}
          setError={setError}
          inputEmail={inputEmail}
          setPageComponent={setPageComponent}
          showPassword={showPassword}
          inputPassword={inputPassword}
          handlePasswordChange={handlePasswordChange}
          setShowPassword={setShowPassword}
          msgPassword={msgPassword}
          logIn={logIn}
          setMsgPassword={setMsgPassword}
          setButtonText={setButtonText}
          setInputEmail={setInputEmail}
          userNotFound={userNotFound}
          setUserNotFound={setUserNotFound}
          setInputPassword={setInputPassword}

        />
      )}
      {pageComponent === 'loginEmail' && (
        <LoginEmail
          setButtonStatus={setButtonStatus}
          error={error}
          setError={setError}
          inputEmail={inputEmail}
          setPageComponent={setPageComponent}
          showPassword={showPassword}
          inputPassword={inputPassword}
          handlePasswordChange={handlePasswordChange}
          setShowPassword={setShowPassword}
          msgPassword={msgPassword}
          logIn={logIn}
          setMsgPassword={setMsgPassword}
          setButtonText={setButtonText}
          setEmailChange={setEmailChange}
          emailChange={emailChange}
          setInputPassword={setInputPassword}
        />

      )}
      {pageComponent === 'confirmSignupEmail' && (
        <ConfirmSignupEmail
          error={error}
          setError={setError}
          inputEmail={inputEmail}
          setPageComponent={setPageComponent}
          setButtonText={setButtonText}
          setEmailChange={setEmailChange}
          emailChange={emailChange}
        />
      )}

      {pageComponent === 'signupEmail' && (
        <SignupEmail
          setEmailChange={setEmailChange}
          signUp={signUp}
          setError={setError}
          error={error}
          showPassword={showPassword}
          inputPassword={inputPassword}
          handlePasswordChange={handlePasswordChange}
          setShowPassword={setShowPassword}
          setButtonStatus={setButtonStatus}
          inputEmail={inputEmail}
          setButtonText={setButtonText}
          setPageComponent={setPageComponent}
          setInputPassword={setInputPassword}
        />
      )}

      {pageComponent === 'confirmForgetEmail' && (
        <ConfirmForgetEmail
          error={error}
          inputEmail={inputEmail}
          setInputEmail={setInputEmail}
          setPageComponent={setPageComponent}
          setError={setError}
          setTimeLeft={setTimeLeft}
          forgetPassword={forgetPassword}
          setButtonText={setButtonText}
        />
      )}

      {pageComponent === 'enterCode' && (
        <EnterCode
          setCode={setCode}
          code={code}
          inputEmail={inputEmail}
          error={error}
          setButtonStatus={setButtonStatus}
          setPageComponent={setPageComponent}
          setError={setError}
          setButtonText={setButtonText}
        />
      )}

      {pageComponent === 'newPassword' && (
        <ResetPassword
          code={code}
          handlePassword2Change={handlePassword2Change}
          inputPassword2={inputPassword2}
          setError={setError}
          logIn={logIn}
          showPassword={showPassword}
          inputPassword={inputPassword}
          handlePasswordChange={handlePasswordChange}
          setShowPassword={setShowPassword}
          setButtonStatus={setButtonStatus}
          inputEmail={inputEmail}
          setButtonText={setButtonText}
          setPageComponent={setPageComponent}
          setInputPassword={setInputPassword}
          setInputPassword2={setInputPassword2}
        />
      )}

      {pageComponent === 'signinSuccess' && (
        <SuccesLogin
          setButtonStatus={setButtonStatus}
          setButtonIcon={setButtonIcon}
          setButtonText={setButtonText}
        />
      )}

      <MyButton style={{ pointerEvents: buttonStatus === 'green' ? 'none' : 'auto' }} buttonText={buttonText} onClick={handleContinueClick} className={error ? 'error' : ''} buttonStatus={buttonStatus} buttonIcon={buttonIcon} />
      {(pageComponent === 'checkEmail') && (

        <div className="googlesingup-bottom">

          <div className="googlesingup-bottom-login">
            Already have an account?{" "}
            <Link
              onClick={() => { setPageComponent('loginToEmail'); setError(false) }}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                textDecorationColor: "#000",
              }}
            >
              Log in
            </Link>
          </div>

          <div className="googlesingup-bottom-term">
            By continuing I agree to the
            <br />{" "}
            <span
              onClick={termChange}
            >
              Terms & Conditions
            </span>
            ,{" "}
            <span
              onClick={privacyChange}
            >
              Privacy Policy
            </span>
          </div>
        </div>
      )}
      {(pageComponent === 'loginEmail' || pageComponent === 'loginToEmail') && (
        <div className="block-button">
          <div className="forget"
            onClick={() => { setPageComponent('confirmForgetEmail'); trackP1Event('web_click_forgotpassword', {}); setError(false) }}
            style={{ cursor: "pointer", textDecoration: "underline", }}
          >
            Forgot password?
          </div>
        </div>
      )}
      {pageComponent === 'enterCode' && (
        <div className="block-button">
          {timeLeft > 0 ? (
            <div className="forget">
              Wait 00:{timeLeft} to resend
            </div>
          ) : (
            <div className="forget">
              Didn’t receive the code?   <span style={{ textDecoration: "underline" }} onClick={() => { forgetPassword(inputEmail); setTimeLeft(30); trackP1Event('web_forgot_code_resend', {}) }}>Resend a code </span>
            </div>
          )}
        </div>
      )}
    </div >
  );
}
export default Signup;
